// gameserver network
var appPropLocal = {
  gameServerURL: "ws://localhost:12321/rps",
  boardURL: "http://localhost:12321/board",
  useTLS: false,
  skipInsecureTLS: true
};

var appSSDNODES4 = {
  gameServerURL: "ws://63.250.52.190:12321/rps",
  boardURL: "http://63.250.52.190:12321/board",
  useTLS: false,
  skipInsecureTLS: true
};

var appSSDNODES38 = {
  gameServerURL: "ws://209.182.235.114:12321/rps",
  boardURL: "http://209.182.235.114:12321/board",
  useTLS: false,
  skipInsecureTLS: true
};

var appHANAPEGI = {
  gameServerURL: "wss://hanapegi.dekey.app:8123/rps",
  boardURL: "https://hanapegi.dekey.app:8123/board",
  myrecordURL: "https://hanapegi.dekey.app:8123/myrecord",
  getuserinfoURL: "https://hanapegi.dekey.app:8123/getuserinfo",
  updateuserURL: "https://hanapegi.dekey.app:8123/updateuser",
  mycreditURL: "https://hanapegi.dekey.app:8123/mycredit",
  pointbyteamURL: "https://hanapegi.dekey.app:8123/pointsbyteam",
  finddiscordidURL: "https://hanapegi.dekey.app:8123/getuserinfoofdiscordid",
  getnftinfoURL: "https://hanapegi.leedo.games:8123/getnftinfo",
  useTLS: false,
  skipInsecureTLS: true
};

var appOfficialHANAPEGI = {
  gameServerURL: "wss://hanapegi.leedo.games:8123/rps",
  boardURL: "https://hanapegi.leedo.games:8123/board",
  myrecordURL: "https://hanapegi.leedo.games:8123/myrecord",
  getuserinfoURL: "https://hanapegi.leedo.games:8123/getuserinfo",
  updateuserURL: "https://hanapegi.leedo.games:8123/updateuser",
  mycreditURL: "https://hanapegi.leedo.games:8123/mycredit",
  pointbyteamURL: "https://hanapegi.leedo.games:8123/pointsbyteam",
  finddiscordidURL: "https://hanapegi.leedo.games:8123/getuserinfoofdiscordid",
  getnftinfoURL: "https://hanapegi.leedo.games:8123/getnftinfo",
  useTLS: false,
  skipInsecureTLS: true
};

const appProp = appOfficialHANAPEGI;

export default appProp;
